<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb
                        :page-title="$t('lead_groups')"
                        :directory="[$t('cost'), $t('cost_type')]"
                        :icon="'clipboard'"/>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button
                            type="button"
                            class="btn btn-primary btn-with-shadow"
                            @click.prevent="openModal">
                        {{ $t('add_leads_group') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="'cost-type-table'" :options="options" @action="getAction"/>

        <app-cost-type-modal v-if="isModalActive"
                                :table-id="tableId"
                                :selected-url="selectedUrlCost"
                                @close-modal="closeModal"/>

        <app-confirmation-modal v-if="confirmationModalActive"
                                modal-id="delete-modal"
                                @confirmed="confirmed"
                                @cancelled="cancelled"/>

    </div>
</template>

<script>

    import {FormMixin} from "@core/mixins/form/FormMixin";
    import {DeleteMixin} from "@app/Mixins/Global/DeleteMixin";
    import { collection, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";

    export default {
        name: "CostTypeList",
        mixins: [FormMixin, DeleteMixin],
        data() {
            return {
                numberWithCurrencyMuseum,
                confirmationModalActive: false,
                isModalActive: false,
                tableId: 'cost-type-table',
                selectedUrlCost: '',
                options: {
                    name: this.$t('pipeline_table'),
                    url: 'crm/cost/types',
                    showHeader: true,
                    columns: [
                        {
                            title: this.$t('name'),
                            type: 'text',
                            key: 'name',
                        }, 
						{
                            title: this.$t('cost_type_count'),
                            type: 'text',
                            key: 'total_count',
                        },
                        {
                            title: this.$t('cost_type_price'),
                            type: 'custom-html',
                            key: 'total_price',
                            modifier: (value, row) => {
                                return value ? `<span class="text-nowrap">${numberWithCurrencyMuseum(value)}</span>` : '-';

                            }
                        },
                      
				
                        {
                            title: 'Action',
                            type: 'action',
                            key: 'invoice',
                            isVisible: true
                        },
                    ],
                    filters: [
                      

                    ],
                    showSearch: true,
                    showFilter: true,
                    paginationType: "pagination",
                    responsive: false,
                    rowLimit: 20,
                    showAction: true,
                    orderBy: 'desc',
                    actionType: "default",
                    actions: [
                        {
                            title: this.$t('edit'),
                            icon: 'edit',
                            type: 'modal',
                            component: 'app-cost-type-modal',
                            modalId: 'cost-type-modal',

                        }, {
                            title: this.$t('delete'),
                            icon: 'trash',
                            type: 'modal',
                            component: 'app-confirmation-modal',
                            modalId: 'delete-modal',
                            url: '',
                        },
                    ],
                }
            }
        },
        methods: {
            getAction(row, action, active) {

                if (action.title === this.$t('edit')) {
                    this.selectedUrlCost = `crm/cost/types/${row.id}`;
                    this.isModalActive = true;
                } else if (action.title == this.$t('delete')) {

                    this.deleteUrl = `crm/cost/types/${row.id}`;
                    this.confirmationModalActive = true;
                }
            },
            openModal() {
                this.isModalActive = true;
                $('#cost-type-modal').modal('show');
            },
            closeModal() {
                this.isModalActive = false;
                this.selectedUrlCost = '';
                $('#cost-type-modal').modal('hide');
            }
        }
    }
</script>
<style>
    .badge-link {
        color: #0f37da;
    }
</style>
